import { render, staticRenderFns } from "./DashboardVentasPerdidosCenter.vue?vue&type=template&id=075cde93&scoped=true&lang=pug"
import script from "./DashboardVentasPerdidosCenter.vue?vue&type=script&lang=js"
export * from "./DashboardVentasPerdidosCenter.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentasPerdidosCenter.vue?vue&type=style&index=0&id=075cde93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075cde93",
  null
  
)

export default component.exports